export default __webpack_public_path__ + "static/media/left-square-shape.d97f8a4f.png";